// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1293600714
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { ProviderOptionWithDistance } from './models/provider/provideroptionwithdistance';
import { ClinicSummary } from './models/provider/clinicsummary';
import { FacilitySummary } from './models/nonentity/facilitysummary';
import { ProcedureSummary } from './models/nonentity/proceduresummary';
import { GroupSummary } from './models/provider/groupsummary';
import { ContractSummary } from './models/nonentity/contractsummary';
import { Document } from './models/provider/document';
import { BlobResult } from './models/common/blobresult';
import { UploadObject } from '../shared/models/uploadobject';
import { ProviderListItem } from './models/provider/providerlistitem';
import { Provider } from './models/provider/provider';
import { Certification } from './models/provider/certification';
import { Education } from './models/provider/education';
import { Affiliation } from './models/provider/affiliation';
import { License } from './models/provider/license';

export interface getOptionsWithDistances_Filter {
  procedureItemCategoryId: number;
  procedureItemId: number;
  name: string;
  latitude: number;
  longitude: number;
}

export interface getClinicsByProviderId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getProviderProviderGroupClinics_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
  showAll: boolean;
}

export interface getFacilitiesByProviderId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getProceduresByProviderId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getGroupsByProviderId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getContractsByProviderId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getProviderById_Filter {
  includeChildren: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ProvidersApiService {
  constructor(protected http: HttpClient) {}

  getOptionsWithDistances(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getOptionsWithDistances_Filter>
  ): Observable<SmartListResult<ProviderOptionWithDistance>> {
    let url = environment.chiliSauceApiRoot + `/api/Providers/options`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProviderOptionWithDistance>>(url, {
      params: params,
    });
  }

  getClinicsByProviderId(
    providerGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getClinicsByProviderId_Filter>
  ): Observable<SmartListResult<ClinicSummary>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}/clinics`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ClinicSummary>>(url, {
      params: params,
    });
  }

  updateClinicsForProviderId(
    providerGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}/clinics`;
    return this.http.put<any>(url, ids);
  }

  getProviderProviderGroupClinics(
    providerGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProviderProviderGroupClinics_Filter>
  ): Observable<SmartListResult<ClinicSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/clinics/all`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ClinicSummary>>(url, {
      params: params,
    });
  }

  getFacilitiesByProviderId(
    providerGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFacilitiesByProviderId_Filter>
  ): Observable<SmartListResult<FacilitySummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/facilities`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<FacilitySummary>>(url, {
      params: params,
    });
  }

  updateFacilitiesForProviderId(
    providerGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/facilities`;
    return this.http.put<any>(url, ids);
  }

  getProceduresByProviderId(
    providerGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProceduresByProviderId_Filter>
  ): Observable<SmartListResult<ProcedureSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/procedures`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProcedureSummary>>(url, {
      params: params,
    });
  }

  updateProceduresForProviderId(
    providerGuid: string,
    ids: number[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/procedures`;
    return this.http.put<any>(url, ids);
  }

  getGroupsByProviderId(
    providerGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getGroupsByProviderId_Filter>
  ): Observable<SmartListResult<GroupSummary>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}/groups`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<GroupSummary>>(url, {
      params: params,
    });
  }

  updateGroupsForProviderId(
    providerGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}/groups`;
    return this.http.put<any>(url, ids);
  }

  getContractsByProviderId(
    providerGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getContractsByProviderId_Filter>
  ): Observable<SmartListResult<ContractSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/contracts`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ContractSummary>>(url, {
      params: params,
    });
  }

  updateContractsForProviderId(
    providerGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/contracts`;
    return this.http.put<any>(url, ids);
  }

  getDocumentsByProviderId(providerGuid: string): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/documents`;
    return this.http.get<Document[]>(url);
  }

  addProviderDocuments(
    providerGuid: string,
    documents: Document[]
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/documents`;
    return this.http.post<Document[]>(url, documents);
  }

  uploadDocument(upload: UploadObject, metadata: any): Subject<void> {
    const url = environment.chiliSauceApiRoot + `/api/Providers/upload`;

    if (!upload.file) {
      console.warn('no file specified to upload');
      return;
    }

    const subject = new Subject<void>();
    const fileToUpload = upload.file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    let headers: HttpHeaders = null;
    if (metadata) {
      headers = new HttpHeaders({
        UploadMetadata: JSON.stringify(metadata),
      });
    }

    this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          upload.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const response = <BlobResult>event.body;
          upload.url = response.blobAddress;
          subject.next();
          subject.complete();
        }
      });

    return subject;
  }

  getAllProviders(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<ProviderListItem>> {
    let url = environment.chiliSauceApiRoot + `/api/Providers`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<ProviderListItem>>(url);
  }

  addProvider(newProvider: Provider): Observable<Provider> {
    const url = environment.chiliSauceApiRoot + `/api/Providers`;
    return this.http.post<Provider>(url, newProvider);
  }

  getProviderById(
    providerGuid: string,
    queryParams?: Partial<getProviderById_Filter>
  ): Observable<Provider> {
    const url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Provider>(url, { params: params });
  }

  updateProvider(provider: Provider, providerGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}`;
    return this.http.put<any>(url, provider);
  }

  deleteProvider(providerGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}`;
    return this.http.delete(url);
  }

  updateProviderCertification(
    certification: Certification,
    providerGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/certifications`;
    return this.http.post<any>(url, certification);
  }

  deleteProviderCertification(
    providerGuid: string,
    certificationGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/certifications/${certificationGuid}`;
    return this.http.delete(url);
  }

  updateProviderEducation(
    education: Education,
    providerGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/education`;
    return this.http.post<any>(url, education);
  }

  deleteProviderEducation(
    providerGuid: string,
    educationGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/education/${educationGuid}`;
    return this.http.delete(url);
  }

  updateProviderAffiliation(
    affiliation: Affiliation,
    providerGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/affiliation`;
    return this.http.post<any>(url, affiliation);
  }

  deleteProviderAffiliation(
    providerGuid: string,
    affiliationGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/affiliation/${affiliationGuid}`;
    return this.http.delete(url);
  }

  updateProviderLicense(
    license: License,
    providerGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Providers/${providerGuid}/license`;
    return this.http.post<any>(url, license);
  }

  deleteProviderLicense(
    providerGuid: string,
    licenseGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Providers/${providerGuid}/license/${licenseGuid}`;
    return this.http.delete(url);
  }
}
